import { ICON_COLOR } from '@zep-us/zus/tokens';
import { logger } from '@zep/core-logger';
import { learningMaterialFileModal } from '@/components/modals/LearningMaterialModal';
import { PaperIcon } from '@/icons';
import { type LearningMaterial } from '@/views/build/modal/LearningMaterialUploadModal';

/**
 * Material content section component
 * Displays file icon and clickable filename
 *
 * @description
 * Matches Figma design (node 28129:16318 "Contents")
 * - Container: px-lg (24px), no gap (only one child "File")
 * - File (28129:16319): gap-md (16px) between icon and filename
 */
export interface MaterialContentSectionProps {
  learningMaterial: LearningMaterial;
}
export const MaterialContentSection = ({
  learningMaterial
}: MaterialContentSectionProps) => {
  return <div className="flex w-full flex-col px-lg" data-sentry-component="MaterialContentSection" data-sentry-source-file="MaterialContentSection.tsx">
      {/* File - matches Figma node 28129:16319 */}
      <div className="flex items-center gap-md">
        {/* Icon - 32px container from Figma node 28129:16320 */}
        <div className="flex size-[32px] shrink-0 items-center justify-center">
          <PaperIcon size="xl" fill={ICON_COLOR.alternative} data-sentry-element="PaperIcon" data-sentry-source-file="MaterialContentSection.tsx" />
        </div>

        {/* Filename - clickable with underline, matches node 28129:16321 */}
        <div className="flex shrink-0 flex-col items-start justify-center">
          <span className="cursor-pointer text-body-lg-semibold text-default underline" onClick={async () => {
          logger.track('view_learningMaterial', {
            from: 'quizDetail'
          });
          await learningMaterialFileModal.openAsync({
            file: learningMaterial,
            alwaysHasCloseButton: true
          });
        }}>
            {learningMaterial.originalFileName}
          </span>
        </div>
      </div>
    </div>;
};